'use client'

import { useEffect } from 'react'

import { CrashReporter } from '@viziertronic/crash-reporter'

import { useBrowserRuntime } from '#runtime/browser.runtime.ts'

export interface ErrorHandlerProps {
  error: Error & { digest?: string }
  reset(): void
}

export default function ErrorHandler({ error, reset }: ErrorHandlerProps) {
  const runtime = useBrowserRuntime()
  useEffect(() => {
    runtime.runPromise(CrashReporter.use((cr) => cr.report(error)))
  }, [error, runtime])

  return (
    <main>
      <h2>Something went wrong!</h2>
      <button onClick={() => reset()}>Try again</button>
    </main>
  )
}
